import React from 'react';
import {
  Box,
  FormControlLabel,
  FormHelperText,
  Stack,
  Switch,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SALON_SECTION_VISIBILITY_KEYS } from '../../../theme/salonPublicLayout';


const SalonSectionVisibilityControls = ({
  value,
  onChange,
  disabled = false,
  errors = {},
  registerFieldRef,
}) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={0.5}>
      {SALON_SECTION_VISIBILITY_KEYS.map((sectionKey) => {
        const error = Array.isArray(errors?.[sectionKey])
          ? errors[sectionKey][0]
          : errors?.[sectionKey];
        const errorId = `salon-visibility-${sectionKey}-error`;

        return (
          <Box key={sectionKey}>
            <FormControlLabel
              label={t(`salon_theme.styles.sections.${sectionKey}`)}
              labelPlacement="start"
              control={(
                <Switch
                  checked={value?.[sectionKey] !== false}
                  onChange={(event) => onChange(
                    sectionKey,
                    event.target.checked,
                  )}
                  disabled={disabled}
                  inputRef={(element) => registerFieldRef?.(
                    sectionKey,
                    element,
                  )}
                  inputProps={{
                    name: `visibility.${sectionKey}`,
                    'aria-describedby': error ? errorId : undefined,
                  }}
                />
              )}
              sx={{
                m: 0,
                minHeight: 44,
                width: '100%',
                justifyContent: 'space-between',
                gap: 2,
                '& .MuiFormControlLabel-label': {
                  fontSize: '0.9rem',
                  fontWeight: 600,
                },
              }}
            />
            {error && (
              <FormHelperText id={errorId} error sx={{ mt: -0.5, mb: 0.5 }}>
                {error}
              </FormHelperText>
            )}
          </Box>
        );
      })}
    </Stack>
  );
};

export default SalonSectionVisibilityControls;
